import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { mergedPortfolioViewBeforeLoad } from '@/features/portfolio/utils/merged-portfolio/combinedTabRouteGuards';
import { saveLastVisitedView } from '@/features/visualizations/utils/lastVisitedVisualizationView';

const paramsSchema = z.object({
  viewId: z.coerce.number().int().positive(),
});

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/portfolio/view/$viewId')({
  params: paramsSchema,
  beforeLoad: mergedPortfolioViewBeforeLoad,
  loader: ({ params }) =>
    saveLastVisitedView(Number(params.loopId), { type: 'view', id: Number(params.viewId) }),
});
